export default __webpack_public_path__ + "static/media/funnelIcon.77e9b71e.svg";